export enum ENUM_DOMAIN_STATUS {
  PENDING = 'PENDING',
  LIVE = 'LIVE',
  FAILED = 'FAILED',
}
